import { useState } from 'react'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import { useAdminFieldReport } from '../../../assets/api/useAdminApi'
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate'
import { DateFormField } from '../../../shared/components/formfields/DataFormField'
import { LocationFilterFields } from '../../../shared/components/LocationFilterFields'

const FieldReports = () => {
    const [filters, setFilters] = useState({});
    const { data: fieldReports, isLoading: isFieldReportLoading } = useAdminFieldReport(filters)
    const fieldReportColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "created_by_name",
            headerName: "created By",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_status",
            headerName: "Apartment Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

    ];

    return (
        <>
            <TableFilterTemplate
                title="Field Report"
                columns={fieldReportColumn}
                rowsData={fieldReports?.data || []}
                isLoading={isFieldReportLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <> 
                        <LocationFilterFields
                            countryField="country_id"
                            stateField="state_id"
                            cityField="city_id"
                            zoneField="zone_id"
                            clusterField="cluster_id"
                            isStoredId={true}
                        />

                        <Grid2 children size={12}>
                            <Field
                                name="from"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values?.to || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to"
                                component={DateFormField}
                                label="End Date"
                                minDate={values?.from || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default FieldReports